import React, { ReactElement } from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { initializeApp } from 'firebase/app';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider, useAuth } from './Context/AuthContext';
import { RouterProvider, useRouter } from './Context/RouterContext';
import Main from './Pages/Main';
import Login from './Pages/Login';
import { Home } from './Pages/Home';
import { Spinner } from 'react-bootstrap';
import SrikandiPage from './Pages/Srikandi';
import SalesPage from './Pages/Sales';
import CommissionPage from './Pages/Commission';
import { CommissionSettings } from './Pages/Commission/Settings';
import DailySales from './Pages/DailySales';
import RemoveTag from './Pages/Commission/Settings/RemoveTag/removeTag';
import ImportCsvPage from './Pages/importCsvPage';
import CSVImporterXilnexCommission from './Pages/Commission/Settings/CSVImprterXilnexCommission';
import AddShopifyTags from './Pages/Commission/Settings/AddShopifyTag/addTag';
import ProductCommissions from './Pages/Commission/ProductCommissions';
import ComboProduct from './Pages/Commission/ComboProduct';
import ExtraBonus from './Pages/Commission/ExtraBonus';
import CP58 from './Pages/Commission/CP58';

const firebaseConfig = {
  apiKey: 'AIzaSyAjkzR1yxgOOfOFOoF-jSf8biY1KyeA3r4',
  authDomain: 'sk-srikandi.firebaseapp.com',
  databaseURL: 'https://sk-srikandi-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'sk-srikandi',
  storageBucket: 'sk-srikandi.appspot.com',
  messagingSenderId: '1071401249580',
  appId: '1:1071401249580:web:7fa69a805438a2aa5e1a89',
  measurementId: 'G-Z3YG97B85V',
};

export const useEmulator = process.env.NODE_ENV === 'development';

export const firebaseApp = initializeApp(firebaseConfig);

const ProtectedRoute = ({
  role,
  children,
}: {
  children: ReactElement<any, any>;
  role?: string;
}) => {
  const { user, loading, dbUser } = useAuth();

  if (loading) {
    return (
      <Spinner
        animation="border"
        role="status"
        className="text-center spinner"
        style={{
          position: 'absolute',
          height: '80px',
          width: '80px',
          top: '50%',
          left: '50%',
          marginLeft: '-50px',
          marginTop: '-30px',
        }}
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }
  if (role && dbUser && dbUser.role !== role) {
    window.alert('Not authorised!');
    return <Navigate to={'/'} />;
  }
  if (!user && !loading) {
    return <Navigate to="/login" />;
  }

  return children;
};

render(
  <BrowserRouter>
    <RouterProvider>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Main />}>
            <Route
              index
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route path="login" element={<Login />} />
            <Route
              path="srikandi/*"
              element={
                <ProtectedRoute>
                  <SrikandiPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="sales"
              element={
                <ProtectedRoute>
                  <SalesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="sales-summary"
              element={
                <ProtectedRoute>
                  <SalesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="commissions"
              element={
                <ProtectedRoute>
                  <CommissionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="commissions/settings"
              element={
                <ProtectedRoute role="admin">
                  <CommissionSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="daily-sales"
              element={
                <ProtectedRoute>
                  <DailySales />
                </ProtectedRoute>
              }
            />
            <Route
              path="remove-tags"
              element={
                <ProtectedRoute>
                  <RemoveTag />
                </ProtectedRoute>
              }
            />
            <Route
              path="add-shopify-tags"
              element={
                <ProtectedRoute>
                  <AddShopifyTags />
                </ProtectedRoute>
              }
            />
            <Route
              path="commission-xilnex"
              element={
                <ProtectedRoute>
                  <CSVImporterXilnexCommission />
                </ProtectedRoute>
              }
            />
            <Route
              path="extra-bonus"
              element={
                <ProtectedRoute>
                  <ExtraBonus />
                </ProtectedRoute>
              }
            />
            <Route
              path="others"
              element={
                <ProtectedRoute>
                  <ImportCsvPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="product-commissions"
              element={
                <ProtectedRoute>
                  <ProductCommissions />
                </ProtectedRoute>
              }
            />
            <Route
              path="combo-product"
              element={
                <ProtectedRoute>
                  <ComboProduct />
                </ProtectedRoute>
              }
            />
            <Route
              path="cp58"
              element={
                <ProtectedRoute>
                  <CP58 />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </RouterProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);
